module.exports = __webpack_public_path__ + "static/media/worksheet-62617.98c434d4.png";